var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77238 2.06905C2.00681 2.06905 1.38619 2.68967 1.38619 3.45524V14.5448C1.38619 15.3103 2.00681 15.9309 2.77238 15.9309H11.0895C11.8551 15.9309 12.4757 15.3103 12.4757 14.5448V9.89043C12.4757 9.71873 12.4677 9.54775 12.452 9.37801C12.3002 8.37917 11.4377 7.61381 10.3964 7.61381H8.95552C7.99855 7.61381 7.22278 6.83804 7.22278 5.88107V4.14834C7.22278 3.07022 6.40225 2.18375 5.35162 2.07934C5.2395 2.0725 5.12685 2.06905 5.0138 2.06905H2.77238ZM2.77238 0.682861H5.14349C5.25146 0.682861 5.35828 0.687799 5.46373 0.69746C7.34074 0.81944 9.09546 1.7007 10.3154 3.14934L12.2325 5.42596C13.1376 6.5007 13.6911 7.8207 13.8283 9.20842C13.8504 9.3668 13.8619 9.52861 13.8619 9.6931V14.5448C13.8619 16.0759 12.6207 17.3171 11.0895 17.3171H2.77238C1.24124 17.3171 0 16.0759 0 14.5448V3.45524C0 1.9241 1.24124 0.682861 2.77238 0.682861ZM11.168 6.31382L9.25505 4.04223C9.02731 3.7718 8.77628 3.52608 8.50614 3.30703C8.57331 3.57637 8.60897 3.85819 8.60897 4.14834V5.88107C8.60897 6.07247 8.76412 6.22762 8.95552 6.22762H10.3964C10.6616 6.22762 10.9198 6.25741 11.168 6.31382Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.1438ae150d8591bc737df836505d06e5.svg";
export { ForwardRef as ReactComponent };